export default {
    isCallFilter: false,
    queryFilter: '',
    filterContentSave: []
};
